import { supabase } from '../../../api';
import { useEffect, useState } from 'react';
import { Grid, Typography, Box } from '@mui/material';

import ArticleCard from '../ArticleCard/ArticleCard';

const SuggestedArticles = (props) => {
  let [allPosts, setAllPosts] = useState([]);

  useEffect(
    () => {
      fetchPosts();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const getRandom = (arr, n) => {
    var result = new Array(n),
      len = arr.length,
      taken = new Array(len);
    if (n > len) throw new RangeError('getRandom: more elements taken than available');
    while (n--) {
      var x = Math.floor(Math.random() * len);
      result[n] = arr[x in taken ? taken[x] : x];
      taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
  };

  const fetchPosts = async () => {
    let { data: posts, error } = await supabase.from('posts').select('*');
    if (error) console.log(error);
    else setAllPosts(posts);
  };

  if (allPosts === undefined) {
    return <Typography>Still loading...</Typography>;
  }

  return (
    <>
      <Box width='100%' textAlign='left' justifyContent='flex-start'>
        <Typography
          variant='h4'
          sx={{
            fontWeight: 'bold',
            m: '1rem',
            mt: '2rem',
          }}>
          Recommended Articles
        </Typography>
        <Typography m='1rem' variant='body1'>
          Hey! We hope you enjoyed this article. Here's a few more specially selected for you!
        </Typography>
      </Box>
      <Grid container alignItems='stretch'>
        {allPosts.length < 3 ? (
          <Typography>Still loading...</Typography>
        ) : (
          getRandom(allPosts, 3)
            .filter((post) => post.id !== props.postId)
            .map((post) => {
              return (
                <ArticleCard
                  key={post.id}
                  id={post.id}
                  summary={post.summary}
                  header={post.data.header}
                  date={post.created_at}
                />
              );
            })
        )}
      </Grid>
    </>
  );
};

export default SuggestedArticles;
